//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { technologicalOperationHasResult } from './ReportCheckListTechnologicalOperationHasResult.js'
import { prepareReportWorks } from '../Report.js'
import ReportCheckListTechnologicalOperation from './ReportCheckListTechnologicalOperation.vue'
import ReportCheckListCheckbox from './ReportCheckListCheckbox.vue'
import { EventBus } from '../../../EventBus/EventBus'
import { LABEL_MARKS } from '../../Request/RequestWorkTypes.js'
import { formatConfiguredTime } from '../../../components/helpers.js'
import ReportCheckListHistoryRecords from './ReportCheckListHistoryRecords.vue'

export default {
  name: 'ReportCheckListWorkType',
  components: {
    ReportCheckListTechnologicalOperation,
    ReportCheckListHistoryRecords,
    ReportCheckListCheckbox
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    workPackage: {
      type: Object,
      default: null
    },
    workType: {
      type: Object,
      required: true
    },
    allWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    allWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    setup: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    showPreviousDepartures: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    openedWorkPackage: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      opened: false,
      showCommentField: false,
      remarked: false,
      dependencies: [],
      dependencyResultValues: [],
      openAll: false,
      technologicalOperationsDoneNumber: 0,
      requiredTechnologicalOperationsNumber: 0,
      workTypeMark: LABEL_MARKS.workType,
      workPackageMark: LABEL_MARKS.workPackage,
      formatConfiguredTime: formatConfiguredTime
    }
  },
  computed: {
    workTypeHeaderAdditionalStyle: function () {
      if (this.setup) {
        return ''
      }
      if (!this.workType.includedInCurrentReport) {
        return ' bg-grey-4'
      } else if (this.workType.done) {
        return ' bg-green-11'
      } else if (this.technologicalOperationsDoneNumber > 0) {
        return ' bg-lime-2'
      } else {
        return ''
      }
    },
    hasComment: function () {
      return this.workType.comment && this.workType.comment != ''
    }
  },
  watch: {
    workType: {
      handler (val) {
        this.$emit('update-work', val)
      },
      deep: true
    },
    dependencyResultValues: {
      handler: function (value) {
        this.calculateResultValuesHideProperty()
        this.calculateTechnologicalOperationHideProperty()
      },
      deep: true
    },
    openedWorkPackage: {
      handler: function (result) {
        if (result) {
          this.opened = true
          this.openAll = true
        } else {
          this.opened = false
          this.openAll = false
        }
        if (this.workType.technologicalOperations.length === 1) {
          this.opened = true
        }
      },
      immediate: true
    }
  },
  created: function () {
    if (!sessionStorage.getItem(this.workType.id.toString() + this.report.id + '_opened') && !sessionStorage.getItem(this.workType.id.toString() + this.report.id + '_openAll')) {
      if (this.setup) {
        this.openAllMethod()
      }

      if (this.workType.technologicalOperations.length === 1) {
        this.opened = true
      }

      this.calculateMustBeOpened()
    } else {
      this.opened = sessionStorage.getItem(this.workType.id.toString() + this.report.id + '_opened') === 'true'
      this.openAll = sessionStorage.getItem(this.workType.id.toString() + this.report.id + '_openAll') === 'true'
    }

    EventBus.$on('task-closed', this.clearSessionStorage)

    this.calculateTechnologicalOperationHideProperty()
    this.getDependencyResultValues()
    this.calculateTechnologicalOperationsDoneNumber()
  },
  beforeDestroy: function () {
    EventBus.$off('task-closed', this.clearSessionStorage)
  },
  methods: {
    getFullWorkTypesCount: function (workPackage) {
      const rawWorkPackage = this.allWorkPackages.find(wP => wP.id === workPackage.id)
      return rawWorkPackage.workTypes.length
    },
    onTechnologicalOperationDuplicated: function (technologicalOperation) {
      const indexTechnologicalOperation = this.workType.technologicalOperations.findIndex(tO => tO.id === technologicalOperation.id && tO.index === technologicalOperation.index)
      const duplicateTechnologicalOperation = JSON.parse(JSON.stringify(technologicalOperation))

      // Для дубликата делаем результат пустым и увеличиваем индекс
      duplicateTechnologicalOperation.done = false
      duplicateTechnologicalOperation.comment = null
      duplicateTechnologicalOperation.user = null
      duplicateTechnologicalOperation.time = null
      duplicateTechnologicalOperation.index++
      for (const workResultsType of duplicateTechnologicalOperation.workResultsTypes) {
        if (workResultsType && workResultsType.resultValues) {
          workResultsType.user = null
          workResultsType.time = null
          for (const resultValue of workResultsType.resultValues) {
            resultValue.value = null
          }
        }
      }
      this.workType.dublicated = true
      this.workType.technologicalOperations.splice(indexTechnologicalOperation + 1, 0, duplicateTechnologicalOperation)
      prepareReportWorks(this.allWorkTypes, this.allWorkPackages, this.report)
    },
    clearSessionStorage: function () {
      sessionStorage.removeItem(this.workType.id.toString() + this.report.id + '_opened', this.opened)
      sessionStorage.removeItem(this.workType.id.toString() + this.report.id + '_openAll', this.openAll)
    },
    openAllMethod: function () {
      if (this.openAll) {
        this.opened = false
        this.openAll = false
      } else {
        this.opened = true
        this.openAll = true
      }
      sessionStorage.setItem(this.workType.id.toString() + this.report.id + '_opened', this.opened)
      sessionStorage.setItem(this.workType.id.toString() + this.report.id + '_openAll', this.openAll)
    },
    inputWorkTypeDone: function () {
      const allTechnologicalOperations = this.workType.technologicalOperations.filter(op => !op.hide)

      // Можем переключить:
      const toggleableTechnologicalOperations = allTechnologicalOperations.filter(op =>
        (!op.resultsRequired || !!op.comment) &&
        !technologicalOperationHasResult(op, this.report, this.workType)
      )

      if (toggleableTechnologicalOperations.length === 0) {
        this.$q.notify({
          type: 'warning',
          message: 'Нет операций для изменения статуса выполнения',
          progress: true,
          timeout: 8000
        })
        return
      }

      const allDone = toggleableTechnologicalOperations.every(op => op.done)
      let changedCount = 0

      for (const op of toggleableTechnologicalOperations) {
        const newValue = !allDone
        if (op.done !== newValue) {
          op.done = newValue
          changedCount++
        }
      }

      if (changedCount === 0) {
        this.$q.notify({
          type: 'warning',
          message: 'Нет операций для изменения статуса выполнения',
          progress: true,
          timeout: 8000
        })
        return
      }

      if (allDone) {
        this.$q.notify({
          type: 'positive',
          message: `Отменено выполнение операций: ${changedCount}`,
          progress: true,
          timeout: 8000
        })
      } else {
        this.$q.notify({
          type: 'positive',
          message: `Выполнено операций: ${changedCount}`,
          progress: true,
          timeout: 8000
        })
      }

      // Не смогли переключить:
      if (!allDone) {
        // Установка done
        const needResultCount = allTechnologicalOperations.filter(op =>
          op.resultsRequired &&
          !op.comment &&
          !technologicalOperationHasResult(op, this.report, this.workType)
        ).length

        if (needResultCount > 0) {
          this.$q.notify({
            type: 'warning',
            message: `Для выполнения ${needResultCount} ${needResultCount === 1 ? 'операции' : 'операций'} требуется заполнить результат или комментарий`,
            progress: true,
            timeout: 8000
          })
        }
      } else {
        // Снятие done
        const hasResultCount = allTechnologicalOperations.filter(op =>
          technologicalOperationHasResult(op, this.report, this.workType)
        ).length

        if (hasResultCount > 0) {
          this.$q.notify({
            type: 'warning',
            message: `Для отмены выполнения ${hasResultCount} ${hasResultCount === 1 ? 'операции' : 'операций'} требуется очистить результат`,
            progress: true,
            timeout: 8000
          })
        }
      }
    },
    calculateTechnologicalOperationsDoneNumber: function () {
      for (const technologicalOperation of this.workType.technologicalOperations) {
        if (technologicalOperation.done && (technologicalOperation.required || technologicalOperation.resultsRequired)) {
          this.technologicalOperationsDoneNumber++
        }
      }
    },
    calculateMustBeOpened: function () {
      let hasRemarkedTechnologicalOperation = false
      for (const technologicalOperation of this.workType.technologicalOperations) {
        if (technologicalOperation.remark || (!technologicalOperation.done && (technologicalOperation.required || technologicalOperation.resultsRequired) && this.roleExecutor)) {
          hasRemarkedTechnologicalOperation = true
          break
        }
      }

      if (!hasRemarkedTechnologicalOperation) {
        this.remarked = false
      } else {
        this.opened = true
        this.remarked = true

        this.$emit('remark-changed')
      }
    },
    calculateTechnologicalOperationHideProperty: function () {
      this.dependencies = []
      this.requiredTechnologicalOperationsNumber = 0
      for (const technologicalOperation of this.workType.technologicalOperations) {
        if (technologicalOperation.required || technologicalOperation.resultsRequired) {
          this.requiredTechnologicalOperationsNumber++
        }

        let sumResultValuesHide = technologicalOperation.workResultsTypes.length !== 0
        for (const workResultsType of technologicalOperation.workResultsTypes) {
          for (const resultValue of workResultsType.resultValues) {
            if (resultValue.dependency && typeof resultValue.dependency.hide === 'boolean') {
              sumResultValuesHide = sumResultValuesHide && resultValue.dependency.hide
              this.dependencies.push(resultValue.dependency)
            } else {
              sumResultValuesHide = false
              break
            }
          }
        }

        if (sumResultValuesHide && !technologicalOperation.hide) {
          technologicalOperation.hide = true
          if (technologicalOperation.done) {
            technologicalOperation.done = false
          }
        } else if (!sumResultValuesHide && technologicalOperation.hide) {
          technologicalOperation.hide = false
        }

        if (technologicalOperation.hide && (technologicalOperation.required || technologicalOperation.resultsRequired)) {
          this.requiredTechnologicalOperationsNumber--
        }
      }
      this.calculateDonePartially()
    },
    getDependencyResultValues: function () {
      for (const dependency of this.dependencies) {
        if (dependency.id) {
          for (const technologicalOperation of this.workType.technologicalOperations) {
            for (const workResultsType of technologicalOperation.workResultsTypes) {
              for (const resultValue of workResultsType.resultValues) {
                if (dependency.id === resultValue.id) {
                  this.dependencyResultValues.push(resultValue)
                }
              }
            }
          }
        }
      }
    },
    calculateResultValuesHideProperty: function () {
      for (const dependency of this.dependencies) {
        if (dependency.id) {
          for (const dependencyResultValue of this.dependencyResultValues) {
            if (dependency.id === dependencyResultValue.id) {
              if (dependency.value === dependencyResultValue.value) {
                dependency.hide = false
              } else {
                dependency.hide = true
              }
            }
          }
        }
      }
    },
    onWorkTypeHeaderName: function () {
      this.opened = !this.opened
      if (!this.opened) {
        this.openAll = false
        sessionStorage.setItem(this.workType.id.toString() + this.report.id + '_openAll', this.openAll)
      }
      sessionStorage.setItem(this.workType.id.toString() + this.report.id + '_opened', this.opened)
    },
    onTechnologicalOperationRemarkChanged: function () {
      this.calculateMustBeOpened()
    },
    onTechnologicalOperationDoneChanged: function (technologicalOperation) {
      if (!this.workType.includedInCurrentReport) {
        return
      }
      if (technologicalOperation.hide) {
        return
      }
      if (this.requiredTechnologicalOperationsNumber > 0) {
        if ((technologicalOperation.required || technologicalOperation.resultsRequired)) {
          if (technologicalOperation.done) {
            this.technologicalOperationsDoneNumber++
          } else {
            this.technologicalOperationsDoneNumber--
          }
        }
        this.workType.done = this.technologicalOperationsDoneNumber === this.requiredTechnologicalOperationsNumber
      } else {
        for (const technologicalOperation of this.workType.technologicalOperations) {
          if (technologicalOperation.done) {
            this.workType.done = true
            break
          } else {
            this.workType.done = false
          }
        }
      }
      this.calculateDonePartially()
    },
    calculateDonePartially: function () {
      const technologicalOperations = this.workType.technologicalOperations.filter(tO => !tO.hide)
      const technologicalOperationsCountDone = technologicalOperations.filter(op => op.done).length
      const donePartially = technologicalOperationsCountDone > 0 && technologicalOperationsCountDone < technologicalOperations.length
      this.$set(this.workType, 'donePartially', donePartially)
    },
    onTechnologicalOperationCommentChanged: function (result) {
      if (this.workType.technologicalOperations.length <= 1) {
        this.workType.comment = result
      }
    }
  }
}

